import React from "react";
import request from "../../utils/request";
import { toast } from "react-toastify";

const RazorpayPayment = ({ courseData, studentData }) => {
  const handlePayment = async () => {
    const amount =
      courseData?.offer_amount > 0
        ? courseData.offer_amount
        : courseData.actual_amount;

    const orderResponse = await request.post("student/createRazorpayOrder", {
      amount,
    });

    console.log('orderResponse',orderResponse)

    if (!orderResponse?.data?.status) {
      toast.error("Failed to create order");
      return;
    }

    const {
      id: order_id,
      amount: orderAmount,
      currency,
    } = orderResponse.data.order;

    const options = {
      key: "rzp_live_QAK5ArS0wq4kR0", // Replace with Razorpay public key
      amount: orderAmount,
      currency,
      name: "English Studio",
      description: "English Studio Secure Payment",
      image: "https://englishstudio.in/img/logo-es.webp",
      order_id,
      handler: async function (response) {
        const verifyResponse = await request.post("student/subscribeCourse", {
          paymentId: response.razorpay_payment_id,
          razorpay_order_id: response.razorpay_order_id,
          razorpay_signature: response.razorpay_signature,
          amount,
        });

        if (verifyResponse?.data?.status) {
          window.location.href = "/student/dashboard";
        } else {
          toast.error("Payment verification failed");
        }
      },
      prefill: {
        name: studentData?.name,
        email: studentData?.email,
        contact: studentData?.phone,
      },
      theme: {
        color: "#3399cc",
      },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
  };

  return (
    <div>
      <button
        className="btn btn-primary btn-custom w-100"
        onClick={handlePayment}
      >
        Pay Now
      </button>
    </div>
  );
};

export default RazorpayPayment;
